import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { WC_TYPE_MAP_VALUE_TO_LABEL } from './constants';
import { EWCType } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'wcType' as const;

export const wcTypeTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const wcType = getTermValue('wc_type')(jsonQuery);

    if (wcType === null || wcType === EWCType.Any) {
      return null;
    }

    const label = `${WC_TYPE_MAP_VALUE_TO_LABEL[wcType]} санузел`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['wc_type'])(jsonQuery),
};
